<template>
  <div v-if="shopId && !loading">
    <!-- tabs -->
    <v-tabs
      class="shop-tabs"
      slider-color="#C9242B"
      slider-size="4"
      v-model="tab"
    >
      <v-tab
        class="shop-tab-item"
        v-for="ch in shopChannelList"
        :key="ch.id"
        @click="onSelectChannel(ch)"
      >
        <shop-channel-icon
          :channelType="ch.channelType"
          :width="30"
          :borderRadius="8"
        />
        {{ ch.nameTH }}
      </v-tab>
      <v-btn
        class="shop-tab-item add"
        elevation="0"
        color="primary"
        text
        @click="onClickAddChannel"
      >
        <v-icon left>mdi-plus-circle-outline</v-icon>
        เพิ่มช่องทางการเชื่อมต่อ
      </v-btn>
    </v-tabs>
    <div v-if="selectedChannel" class="tw-my-12 tw-mx-4">
      <v-row>
        <!-- form -->
        <v-col>
          <shop-channel-form-shopee
            v-if="selectedChannel.channelType === 1"
            ref="formShopee"
            :companyId="companyId"
            :shopId="shopId"
            @delete="onClickDeleteChannel"
            @save="onSaveChannel"
          />
          <shop-channel-form-lazada
            v-else-if="selectedChannel.channelType === 2"
            ref="formLazada"
            :companyId="companyId"
            :shopId="shopId"
            @delete="onClickDeleteChannel"
            @save="onSaveChannel"
          />
        </v-col>

        <!-- user manual -->
        <v-col>
          <shop-channel-manual-shopee
            v-if="selectedChannel.channelType === 1"
          />
          <shop-channel-manual-lazada
            v-else-if="selectedChannel.channelType === 2"
          />
        </v-col>
      </v-row>
    </div>

    <!-- add channel dialog -->
    <shop-add-channel-dialog
      ref="addChannelDialog"
      v-model="isAddChannelDialogOpen"
      :companyId="companyId"
      :shopId="shopId"
      @success="getData"
    />

    <!-- delete channel dialog -->
    <shop-delete-channel-dialog
      ref="deleteChannelDialog"
      v-model="isDeleteChannelDialogOpen"
      :companyId="companyId"
      :shopId="shopId"
      @success="getData()"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShopChannelFormShopee from './channels/shop-channel-form-shopee.vue'
import ShopChannelManualShopee from './channels/shop-channel-manual-shopee.vue'
import ShopChannelFormLazada from './channels/shop-channel-form-lazada.vue'
import ShopChannelManualLazada from './channels/shop-channel-manual-lazada.vue'
import ShopAddChannelDialog from './shop-add-channel-dialog.vue'
import ShopDeleteChannelDialog from './shop-delete-channel-dialog.vue'
import ShopChannelIcon from './shop-channel-icon.vue'

export default {
  name: 'ShopList',
  components: {
    ShopChannelFormShopee,
    ShopChannelManualShopee,
    ShopChannelFormLazada,
    ShopChannelManualLazada,
    ShopAddChannelDialog,
    ShopDeleteChannelDialog,
    ShopChannelIcon,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    shopId: {
      type: String,
      required: true,
    }
  },
  watch: {
    companyId: function () {
      this.getData()
    },
    shopId: function () {
      this.tab = 0
      this.getData()
    }
  },
  computed: mapState({
    loading: state => state.shopChannels.loading,
    shopChannelList: state => state.shopChannels.list,
  }),
  data: () => ({
    isAddChannelDialogOpen: false,
    isDeleteChannelDialogOpen: false,
    selectedChannel: null,
    tab: 0,
  }),
  methods: {
    async getData(selectedChannelId) {
      if (!selectedChannelId) {
        selectedChannelId = this.$route.params.channelId
      }
      console.log('getting data')
      if (!this.companyId || !this.shopId) {
        return
      }
      await this.$store.dispatch('shopChannels/getList', { companyId: this.companyId, shopId: this.shopId, })
      if (this.shopChannelList.length > 0) {
        // select the specified channel (after newly created)
        if (selectedChannelId) {
          const idx = this.shopChannelList.findIndex(o => o.id === selectedChannelId)
          if (idx >= 0) {
            this.tab = idx
          }
        }
        this.onSelectChannel(this.shopChannelList[this.tab])
      } else {
        this.selectedChannel = null
      }
    },
    onSelectChannel(ch) {
      this.selectedChannel = ch
      this.$nextTick(() => {
        switch (ch.channelType) {
          case 1:
            this.$refs.formShopee.setData(ch)
            break
          case 2:
            this.$refs.formLazada.setData(ch)
            break
        }
      })
    },
    onClickAddChannel() {
      this.$refs.addChannelDialog.reset()
      this.isAddChannelDialogOpen = true
    },
    onClickDeleteChannel() {
      this.$refs.deleteChannelDialog.setData(this.selectedChannel)
      this.isDeleteChannelDialogOpen = true
    },
    onSaveChannel() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-tabs {
  border-bottom: 1px solid #6ec39b;
}

.shop-tab-item {
  min-width: 128px;
  color: black;
  margin-left: 0.5rem;
  padding: 10px;
  border: none;
  background: #f2f2f2;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  text-transform: none;

  &.v-tab--active {
    border: 1px solid #6ec39b;
    background: none;
  }

  &.add {
    height: 100%;
  }

  img {
    margin-right: 0.5rem;
  }
}
</style>